export default function() {
    const widgetName = 'cardWidgetKnoxvilleCards';
    const widgetOpts = cardWidgetKnoxvilleCardsOpts;
  
    return saffire.widgets.cardWidget($(`#${widgetName}`), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      buyNowButton: {
        visible: false,
        text: 'BUY NOW'
      },
      cardWidgetLoaded: function(data, owl, hasData) {
          $(`#${widgetName} .card-widget-item`).each(function(i) {
            const cardContent = $(this).find('.card-content');

            $(this).attr('target', '_blank');

            switch (i) {
              case 1:
                let fourthItem = data.items[4];
                $(this).attr('href', fourthItem.URL);
                cardContent.html(`<img src="" data-src="${fourthItem.ImageWithPath}" class="lozad">`);
                break;
              case 2:
                let fifthItem = data.items[5];
                $(this).attr('href', fifthItem.URL);
                cardContent.html(`<img src="" data-src="${fifthItem.ImageWithPath}" class="lozad">`);
                break;
              case 3:
                let sixthItem = data.items[6];
                $(this).attr('href', sixthItem.URL);
                cardContent.html(`<img src="" data-src="${sixthItem.ImageWithPath}" class="lozad">`);
                break;
            }
          });
      },
      itemsPerPanel: 1,
      hasImages: true,
      lazyLoadImages: true,
      imageIsBackground: false,
      link: ['all'], // [], ['all'], ['image', 'title', 'description']
      maxItemsVisible: 4,
      moreButton: {
        visible: true,
        text: 'More Info'
      },
      scriptPath:  widgetOpts.scriptPath,
      showDescription: true,
      slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
      slideshowOptions: {
        items: 1,
        loop: true,
        margin: 10,
        navText: ['Prev','Next'],
        nav: true
      },
      textOverImage: false
    });
  
  }